import {useIntl} from 'react-intl'
import {getRoomLabelsTranslated} from 'components/Offer/hooks/useGetRoomLabels'
import {SearchOffer} from 'modules/sapiSearch/slice'

import {getCancellationDeadline} from '@vio/core/src/offer/business/cancellationPenalties'
import {getRoomLabels} from '@vio/core/src/offer/business/getRoomLabels'
import {getMealPlanAmenities} from '@vio/core/src/offer/business/meal'

import type {Offer} from '@vio/core/src/offer/types/offer'

interface useGetRoomOfferLabelsProps {
  offer: Offer
  shouldShowFreeCancellationDate?: boolean
}
export const useGetRoomOfferLabels = ({
  offer,
  shouldShowFreeCancellationDate = false
}: useGetRoomOfferLabelsProps): string[] => {
  const {formatMessage, formatDate} = useIntl()

  if (!offer) return []

  const labels = getRoomLabels({
    offer: {
      ...offer,
      package: {
        amenities: getMealPlanAmenities(offer.mealPlan)
      }
    } as unknown as SearchOffer,
    shouldShowFreeCancellationDate,
    shouldShowYourChoice: false,
    isSplitBooking: false
  })

  const freeCancellationDeadline = getCancellationDeadline(
    offer?.cancellationPenalties
  )

  const freeCancellationDeadlineFormatted = formatDate(
    freeCancellationDeadline,
    {
      day: '2-digit',
      month: 'short',
      timeZone: 'UTC'
    }
  )

  return getRoomLabelsTranslated({
    labels,
    freeCancellationDeadlineFormatted,
    formatMessage
  })
}
